export default __webpack_public_path__ + "static/media/md-card-bg-java.e364959b.png";